export const DEFAULT_CSS_CLASS = "app";

export const WEATHER_TYPE = {
  clouds: `${DEFAULT_CSS_CLASS} cloud`,
  rain: `${DEFAULT_CSS_CLASS} rain`,
  snow: `${DEFAULT_CSS_CLASS} snow`,
  haze: `${DEFAULT_CSS_CLASS} haze`,
  mist: `${DEFAULT_CSS_CLASS} haze`,
  smoke: `${DEFAULT_CSS_CLASS} haze`,
};


export const api = {
  key: "3cd2d041f5b24609f5d2963cca469ef2",
  base: "https://api.openweathermap.org/data/2.5/",
};
